<template>
  <div>
    <b-container fluid>
      <b-row style="margin-bottom: 5px;">
        <b-col cols="auto">
          查詢起訖時間:
        </b-col>
        <b-col cols="10">
          <b-input-group style="width: 20vh;display: inline-flex;">
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.minvalue"
              style="width: 13vh;"
              min="1960-01-01"
              :max="twtimeparse(timepicker.maxvalue)"
            ></datepicker>
          </b-input-group>
          <span style="display: inline-flex; margin-right: 1rem">~</span>
          <b-input-group
            style="width: 20vh;display: inline-flex; margin-right: 1rem;"
          >
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.maxvalue"
              style="width: 13vh;"
              :min="twtimeparse(timepicker.minvalue)"
              :max="timepicker.max"
            ></datepicker>
          </b-input-group>
          <template v-if="ifloading">
            <b-spinner
              style="width: 1.5rem; height: 1.5rem;"
              variant="success"
              label="Spinning"
            />
          </template>
        </b-col>
      </b-row>
      <b-row
        v-show="fruit.fruitlist.items.length > 0"
        style="margin-bottom: 5px;"
      >
        <b-col cols="auto">
          市場作物:
        </b-col>
        <b-col cols="10">
          <v-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-show="fruit.fruitlist.items.length > 0"
            v-model="fruit.fruitlist.value"
            :options="fruit.fruitlist.options"
            :selectable="(car) => car.disabled"
          ></v-select>
        </b-col>
      </b-row>
      <div v-show="fruit.marketlist.options.length > 0">
        <b-row style="margin-bottom: 5px;">
          <b-col cols="auto">
            交易市場名稱:
          </b-col>
          <b-col cols="10">
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-show="fruit.marketlist.options.length > 0"
              v-model="fruit.marketlist.value"
              :options="fruit.marketlist.options"
              :state="state"
            >
              <b-form-invalid-feedback :state="state"
                >請勿選超過3個市場</b-form-invalid-feedback
              >
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <template v-if="fruit.marketlist.value.length > 0">
          <b-row style="margin-bottom: 5px;">
            <b-col cols="auto">
              產地價格:
            </b-col>
            <b-col cols="10">
              <b-form-checkbox
                id="checkbox-1"
                v-show="fruit.marketlist.options.length > 0"
                v-model="fruit.averageprice"
                :value="true"
                :unchecked-value="false"
                >嘉義縣產地均價</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 15px;">
            <b-col cols="auto">
              價格監控:
            </b-col>
            <b-col cols="10">
              <b-form-checkbox
                id="checkbox-2"
                v-show="fruit.marketlist.options.length > 0"
                v-model="fruit.maintainprice"
                :value="true"
                :unchecked-value="false"
                >農糧署產地價格監控</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 5px;">
            <b-col>
              <b-form-checkbox
                id="checkbox-3"
                v-show="fruit.obj.chart.options.yaxis.length > 0"
                v-model="dataLabels"
                :value="true"
                :unchecked-value="false"
                >顯示數值標籤
              </b-form-checkbox>
            </b-col>
          </b-row>
        </template>
      </div>
    </b-container>
        <!--轉圖片TEST-->
    <!-- <b-button
          @click="downloadPng()"
          variant="dark"
          >Download PNG
    </b-button> -->
    <!-- <b-overlay :show="fruit.ifchartshow" rounded="sm">       -->
      <div style="width: 100%;">
        <div id="apexchartImg"  style="width: 100%;">
          <b-button @click="downloadPng()" variant="secondary" style="position: absolute; right: 0; z-index: 20; margin-right: 30px; font-size: 10px; padding: 3px;">Download PNG</b-button>
          <apexchart
            ref="chart1ref"
            height="450"
            type="line"
            :options="fruit.obj.chart.options"
            :series="fruit.obj.chart.series"
            :responsive="true"
          ></apexchart>
        </div>
      </div>
    <!-- </b-overlay> -->
    <div>※值為0代表無資料</div>
  </div>
</template>

<script>
import CROPCODELIST from "@/data/CROP_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";
import html2canvas from "html2canvas"; //轉圖片TEST
import Canvas2Image from "../../public/js/canvas2image.js"; //轉圖片TEST

//import domtoimage from "dom-to-image";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    //var thisyear = now.getFullYear();
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 30); //取前30天的日期
    //minDate.setDate(date.getDate() - 365);//取一年前的日期

    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      dataLabels:true,
      fruit: {
        fruitlist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
          BA_items:[],
        },
        marketlist: {
          value: [],
          options: [],
          allitems: [],
          items: [],
        },
        mainlist: [],
        iffirst: true,
        ifchartshow: false,
        averageprice: false,
        maintainprice: false,
        overylayshow: true,
        obj: {
          chart: {
            series: [],
            options: {
              chart: {
                height: 450,
                responsive :true,
                type: "line",
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text: "",
              },
              dataLabels: {
                enabled: true,
              },
              stroke: {},
              // stroke: {
              //   show: true,
              //   width: [],
              //   curve: "straight",
              //   dashArray: [],
              // },
              noData: {
                text: "請選擇市場作物",
                align: "center",
                verticalAlign: "middle",
              },
              labels: [],
              yaxis: [],
              colors: [
                "#33a5fb",
                "#775dd0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
                "#6f5c5d",
                "#88715c",
                "#86a3be",
                // "#008FFB",
                // "#19535f",
                // "#FEB019",
                // "#FF4560",
                // "#775DD0",
                // "#1c22ce",
                // "#ff7b3d",
                // "#f9b5c0",
                // "#4c1a11",
              ],
              // xaxis: {
              //   type: "datetime",
              //   labels: {
              //     formatter: function(value, timestamp) {
              //       var date = new Date(timestamp);
              //       if (date.getFullYear() < 1975) return;
              //       var year = date.getFullYear() - 1911;
              //       return (
              //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
              //       ); // The formatter function overrides format property
              //     },
              //   },
              // },
              plotOptions: {
                bar: {
                  columnWidth: "20%",
                },
              },
              grid: {
                padding: {
                  right: 10,
                  left: 10,
                },
              },
            },
          },
        },
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "農產品交易價量分析",
          active: true,
        },
      ],
      ifloading: true,
      cropcodelist: CROPCODELIST,
      // timepicker: {
      //     minvalue: minDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     maxvalue: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     max: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     min: minDate.toLocaleString().split(' ')[0].split('/').join('-')
      // },
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-07-12",
        // maxvalue: "110-07-15",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        min: minDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      croplandlist: [],
      apiGetCropForChart: (data) =>
        this.userRequest.post("/API/Default/getCropForChart", data),
      apiGetCropFromDate: (data) =>
        this.userRequest.post("/API/Default/getCropFromDate", data),
      apiGetMarketFromCrop: (data) =>
        this.userRequest.post("/API/Default/getMarketFromCrop", data),
    };
  },
  created() {
    this.checkLogin();
    // this.init();
  },
  components: {
    datepicker,
  },
  computed: {
    state() {
      return this.fruit.marketlist.value.length > 3 ? false : null;
    },
  },
  // mounted(){
  //     // this.FunctionToken(this.getCropLandList, {});

  // },
  watch: {
    "fruit.fruitlist.value"(value) {
      this.getmarketdetial(value.code);
    },
    "timepicker.maxvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "timepicker.minvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "fruit.marketlist.value"(value) {
      if (value.length > 0) this.optionscheck();
      else this.chartinit();
    },
    "fruit.averageprice"() {
      this.optionscheck();
    },
    "fruit.maintainprice"() {
      this.optionscheck();
    },
    "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
    }
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000002", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      }
    },
    getCropFromDate(data) {
      this.apiGetCropFromDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.CROP,
                code: x.CROP_CODE,
                disabled: true,
              };
              this.fruit.fruitlist.items.push(obj);
            });
            this.fruit.fruitlist.options = this.fruit.fruitlist.items.slice(0);
            this.fruit.fruitlist.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            let cropname = this.$route.params.Crop;
            if (this.IsNull(cropname) != "") {
              let index = this.fruit.fruitlist.options.findIndex(
                (x) => x.code == cropname.CROP_CODE
              );
              if (index != -1) {
                let subitem = this.fruit.fruitlist.options[index];
                this.fruit.fruitlist.value = {
                  label: subitem.label,
                  code: subitem.code,
                  disabled: false,
                };
                this.getmarketdetial(subitem.code);
              } else {
                this.fruit.fruitlist.value = {
                  label: "請選擇",
                  code: "請選擇",
                  disabled: false,
                };
              }
            } else {
              this.fruit.fruitlist.value = {
                label: "請選擇",
                code: "請選擇",
                disabled: false,
              };
            }
            this.ifloading = false;
            // this.fruit.fruitlist.items = JSON.parse(json.Data)
            // this.createchart()
          }
        })
        .catch((err) => console.warn(err));
    },
    getMarketFromCrop(data) {
      this.apiGetMarketFromCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            this.fruit.marketlist.options = [];
            this.fruit.marketlist.value = [];
            this.fruit.averageprice = false;
            this.fruit.maintainprice = false;
            arr.forEach((x) => {
              let obj = {
                text: x.MARKET,
                value: x.MARKET_CODE,
              };
              this.fruit.marketlist.options.push(obj);
            });
            let obj = {
              text: "全國",
              value: "全國",
            };
            this.fruit.marketlist.options.unshift(obj);
            this.ifloading = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getCropForChart(data) {
      this.apiGetCropForChart(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            console.log("apiGetCropForChart",JSON.parse(json.Data));
            this.fruit.fruitlist.items = JSON.parse(json.Data).CROP_PRICEMNG_TRADE_OUT;
            this.fruit.fruitlist.BA_items = JSON.parse(json.Data).BA_TRADE_M_OUTPUT;
            
            this.createnewchart();
            //this.createnewchart_backup();
          }
        })
        .catch((err) => console.warn(err));
    },
    chartinit() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      this.fruit.obj.chart.options.xaxis = {};
      this.dataLabels=true;
    },
    init() {
      this.fruit.fruitlist.items = [];
      this.fruit.fruitlist.options = [];
      this.fruit.marketlist.options = [];
      this.fruit.marketlist.value = [];
      this.fruit.averageprice = false;
      this.fruit.maintainprice = false;
      this.ifloading = true;
      this.chartinit();
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      // let diff = Math.floor((Date.parse(localmaxtime.join('-')) - Date.parse(localmintime.join('-'))) / 86400000);

      // if(diff>31)
      // {
      //     alert("時間選擇區間不能超過1個月")
      // }
      // else
      // {
      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.getCropFromDate, obj);
      // }
    },
    getmarketdetial(value) {
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let diff = Math.floor(
        (Date.parse(localmaxtime.join("-")) -
          Date.parse(localmintime.join("-"))) /
          86400000
      );

      if (value != "請選擇") {
        if (diff > 366) {
          alert("時間選擇區間不能超過1個月");
        } else {
          this.ifloading = true;
          let obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: value,
          };
          this.FunctionToken(this.getMarketFromCrop, obj);
        }
      }
    },
    getchartdata() {
      if (
        this.fruit.marketlist.value.length > 0 &&
        this.fruit.fruitlist.value.code != "請選擇"
      ) {
        this.ifloading = true;
        // this.fruit.ifchartshow = true
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let allindex = this.fruit.marketlist.value.findIndex(
          (x) => x == "全國"
        );
        let obj = {};

        if (allindex != -1) {
          let optionlist = [];

          this.fruit.marketlist.options.forEach((x) => {
            optionlist.push(x.value);
          });

          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: optionlist,
          };
        } else {
          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: this.fruit.marketlist.value,
          };
        }

        this.FunctionToken(this.getCropForChart, obj);
      }
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    optionscheck() {
      if (this.fruit.marketlist.value.length > 3) {
        alert("市場選項已超過3筆，請重新選擇");
      } else {
        this.getchartdata();
      }
    },
    createnewchart_backup() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      // let serieslist = [], datelist = []
      let mainlist = [],
        datelist = [],
        serieslist = [];

      for (let j in this.fruit.fruitlist.items) {
        let subitem10 = this.fruit.fruitlist.items[j];
        if (datelist.indexOf(subitem10.ANA_DATE) == -1) {
          datelist.push(subitem10.ANA_DATE);
        }
      }
      
      for (let i in this.fruit.marketlist.value) {
        if (this.fruit.marketlist.value[i] == "全國") {
          let list1 = [];
          // marketlength = this.fruit.marketlist.options.length - 1;
          for (let i in datelist) {
            let subtime = datelist[i];
            let allavgprice = 0,
              allvolume = 0,
              count = 0;
            for (let j in this.fruit.fruitlist.items) {
              let subitem2 = this.fruit.fruitlist.items[j];

              if (
                subitem2.ANA_DATE == subtime &&
                subitem2.CROP_CODE == this.fruit.fruitlist.value.code
              ) {
                allavgprice = allavgprice + subitem2.PRICE_AVG;
                allvolume = allvolume + subitem2.VOLUME;
                count++;
              }
            }

            let obj1 = {
              date: subtime,
              avgprice: Math.round(allavgprice / count),
              volume: Math.round(allvolume / count),
            };
            list1.push(obj1);
          }
          let obj2 = { name: "全國", data: list1 };
          mainlist.push(obj2);
        } else {
          let marketindex = this.fruit.marketlist.options.findIndex(
            (x) => x.value == this.fruit.marketlist.value[i]
          );
          let subitem1 = this.fruit.marketlist.options[marketindex].text;
          let list1 = [];
          for (let j in this.fruit.fruitlist.items) {
            let subitem2 = this.fruit.fruitlist.items[j];

            if (
              subitem2.MARKET == subitem1 &&
              subitem2.CROP_CODE == this.fruit.fruitlist.value.code
            ) {
              let obj1 = {
                date: subitem2.ANA_DATE,
                avgprice: subitem2.PRICE_AVG,
                volume: subitem2.VOLUME,
              };
              list1.push(obj1);
            }
          }

          let obj2 = { name: subitem1, data: list1 };
          mainlist.push(obj2);
        }
      }
      //let mainname = ""

      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        for (let t in datelist) {
          let subdate = datelist[t];
          let subindex = element1.data.findIndex((y) => y.date == subdate);
          if (subindex != -1) {
            let element2 = element1.data[subindex];
            avglist.push(element2.avgprice);
            volumelist.push(element2.volume);
          } else {
            avglist.push(0);
            volumelist.push(0);
          }
        }

        let volumeobj = {
          name: element1.name + "交易量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);

        let avgobj = {
          name: element1.name + "拍賣均價",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);

        let volumeoption = {},
          avgoption = {};
        if (k == 0) {
          volumeoption = {
            seriesName: "交易量",
            title: {
              text: "交易量(公斤)",
            },
          };

          avgoption = {
            seriesName: "拍賣均價",
            opposite: true,
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };
        } else {
          volumeoption = {
            seriesName: "交易量",
            show: false,
          };

          avgoption = {
            seriesName: "拍賣均價",
            show: false,
          };
        }

        this.fruit.obj.chart.options.yaxis.push(volumeoption);
        this.fruit.obj.chart.options.yaxis.push(avgoption);
      }
      //this.fruit.averageprice 表示嘉義產地均價是否被勾選 
      //this.fruit.maintainprice 表示農糧署產地價格監控是否被勾選
      if (this.fruit.averageprice || this.fruit.maintainprice) {
        let averagelist2 = [],
          mantainlist2 = [],
          datelist3 = [];
        for (let l in datelist) {
          let dateelement = datelist[l];
          for (let n in this.fruit.fruitlist.items) {
            let subitem5 = this.fruit.fruitlist.items[n];
            if (
              datelist3.indexOf(subitem5.ANA_DATE) == -1 &&
              subitem5.ANA_DATE == dateelement &&
              subitem5.CROP_CODE == this.fruit.fruitlist.value.code
            ) {
              if (this.fruit.averageprice) {
                let avgprice =
                  (subitem5.CM_PRICE_C +
                    subitem5.CM_PRICE_M +
                    subitem5.CM_PRICE_F) /
                  3;
                averagelist2.push(avgprice.toFixed(2));
              }

              if (this.fruit.maintainprice) {
                mantainlist2.push(subitem5.CM_PRICE_MON);
              }
              datelist3.push(subitem5.ANA_DATE);
            }
          }
        }

        if (averagelist2.length > 0) {
          let obj = {
            name: "嘉義縣產地均價",
            type: "line",
            data: averagelist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }

        if (mantainlist2.length > 0) {
          let obj = {
            name: "農糧署產地價格監控",
            type: "line",
            data: mantainlist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length != 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }
      }

      this.fruit.obj.chart.series = serieslist;
      this.fruit.obj.chart.options.labels = datelist;
      // this.fruit.obj.chart.series.forEach((x) => {
      //   x.data.unshift(null);
      //   x.data.push(null);
      // });

      // let labellist = [];

      // for (let l in datelist) {
      //   let subdate3 = datelist[l].split("T")[0].split("-");
      //   subdate3[0] = parseInt(subdate3[0]) - 1911;
      //   labellist.push(subdate3.join("-"));
      // }

      // this.fruit.obj.chart.options.labels = labellist;

      // //往前加一天
      // let date1 = this.getnewdate(labellist[0], 0);
      // this.fruit.obj.chart.options.labels.unshift(date1);

      // //往前減一天
      // let date2 = this.getnewdate(labellist[labellist.length - 1], 1);
      // this.fruit.obj.chart.options.labels.push(date2);
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
        this.ifloading = false;
        // this.fruit.ifchartshow = false
      }
    },
    createnewchart() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      //this.dataLabels=true;

      let mainlist = [],
        datelist = [],//存放日期列表
        serieslist = [],
        maxprice=0,
        maxvolume=0;
      //
      //取得日期
      for (let j in this.fruit.fruitlist.items) {
        let subitem10 = this.fruit.fruitlist.items[j];
        //let subitem10 = this.fruit.fruitlist.items[j].ANA_DATE.split("-");//舊的，顯示月份
        //let subdate10 = subitem10[0] + "-" + subitem10[1];//舊的，顯示月份
        if (datelist.indexOf(subitem10.ANA_DATE) == -1) {
          datelist.push(subitem10.ANA_DATE);
        }
      }
      //console.log("datelist",datelist);
      //交易市場名稱資料
      for (let i in this.fruit.marketlist.value) {
        let list1 = [];
        if (this.fruit.marketlist.value[i] == "全國") {
          // marketlength = this.fruit.marketlist.options.length - 1;
          for (let i in datelist) {
            let subtime = datelist[i];
            let allvolume = 0,count2 = 0;
            let avgvalue1 = 0;
            //9/25 let totalsaleprice = 0,count1 = 0; 
            //allavgprice = 0,
            //全國平均價格直接抓BA_TRADE_M的WA
            for (let j in this.fruit.fruitlist.BA_items) {
              let subitem2 = this.fruit.fruitlist.BA_items[j];
              if (
                subitem2.ANA_DATE == subtime
              ) {
                avgvalue1 = Math.round(subitem2.WA);
              }
            }
            for (let j in this.fruit.fruitlist.items) {
              let subitem2 = this.fruit.fruitlist.items[j];
              if (
                subitem2.ANA_DATE == subtime &&
                subitem2.CROP_CODE == this.fruit.fruitlist.value.code //作物編號
              ) {
                //同一日期的交易量加總及數量計算
                if (subitem2.VOLUME != 0) {
                  allvolume = allvolume + subitem2.VOLUME;
                  count2++;
                }
              }
            }
            //9/25更新前原計算方式(起)
            // for (let j in this.fruit.fruitlist.items) {
            //   let subitem2 = this.fruit.fruitlist.items[j];
            //   //let subdate2 = subitem2.ANA_DATE.split("-");//舊的，顯示月份
            //   //let subtime2 = subdate2[0] + "-" + subdate2[1];//舊的，顯示月份
              
            //   if (
            //     subitem2.ANA_DATE == subtime &&
            //     subitem2.CROP_CODE == this.fruit.fruitlist.value.code //作物編號
            //   ) {
            //     //同一日期的價格平均加總及數量計算
            //     if (subitem2.PRICE_AVG != 0) {
            //       //allavgprice = allavgprice + subitem2.PRICE_AVG;
            //       totalsaleprice = totalsaleprice + (subitem2.PRICE_AVG * subitem2.VOLUME);
            //       count1++;
            //     }
            //     //同一日期的交易量加總及數量計算
            //     if (subitem2.VOLUME != 0) {
            //       allvolume = allvolume + subitem2.VOLUME;
            //       count2++;
            //     }
            //   }
            // }
            //9/25更新前原計算方式(迄)
            let volumevalue1 = 0;
            //9/25 let avgv=0;
            //if (count1 != 0) avgvalue1 = Math.round(allavgprice / count1);//舊均價計算公式
            //9/25更新前原計算方式(起)
            // if (count1 != 0) avgv = totalsaleprice / allvolume;
            // avgvalue1 = avgv.toFixed(1);
            //9/25更新前原計算方式(迄)
            if (count2 != 0) volumevalue1 = Math.round(allvolume / count2);
            if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
            if(volumevalue1 > maxvolume) maxvolume = Math.ceil(volumevalue1);
            let obj1 = {
              date: subtime,
              avgprice: avgvalue1,
              volume: volumevalue1,
            };
            list1.push(obj1);
          }
          let obj2 = { name: "全國", data: list1 };
          mainlist.push(obj2);
        } else {
          let marketindex = this.fruit.marketlist.options.findIndex(
            (x) => x.value == this.fruit.marketlist.value[i]
          );
          let subitem1 = this.fruit.marketlist.options[marketindex].text;//取得市場名稱
          for (let i in datelist) {
            let subtime = datelist[i];
            let allavgprice = 0,
              allvolume = 0,
              count1 = 0,
              count2 = 0;
            for (let j in this.fruit.fruitlist.items) {
              let subitem2 = this.fruit.fruitlist.items[j];
              
              //let subdate2 = subitem2.ANA_DATE.split("-"); //舊的，顯示月份
              //let subtime2 = subdate2[0] + "-" + subdate2[1];//舊的，顯示月份
              if (
                subitem2.MARKET == subitem1 &&
                subitem2.ANA_DATE == subtime &&
                subitem2.CROP_CODE == this.fruit.fruitlist.value.code
              ) {
                if (subitem2.PRICE_AVG != 0) {
                  allavgprice = allavgprice + subitem2.PRICE_AVG;
                  count1++;
                }
                if (subitem2.VOLUME != 0) {
                  allvolume = allvolume + subitem2.VOLUME;
                  count2++;
                }
              }
            }
            let avgvalue1 = 0,
              volumevalue1 = 0;
            if (count1 != 0) avgvalue1 = allavgprice / count1;
            avgvalue1 = avgvalue1.toFixed(1);
            if (count2 != 0) volumevalue1 = Math.round(allvolume / count2);
            if(avgvalue1 > maxprice) maxprice = Math.ceil(avgvalue1);
            if(volumevalue1 > maxvolume) maxvolume = Math.ceil(volumevalue1);
            let obj1 = {
              date: subtime,
              avgprice: avgvalue1,
              volume: volumevalue1,
            };
            list1.push(obj1);
          }
          let obj2 = { name: subitem1, data: list1 };
          mainlist.push(obj2);
        }
      }
      let remainder = maxprice % 5;
      if(remainder != 0) maxprice += (5-remainder);
      let ramainderVolume = Math.ceil(maxvolume / 2000) ;
      if(ramainderVolume != 0) maxvolume =  ramainderVolume * 2000;
      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        for (let t in datelist) {
          let subdate = datelist[t];
          let subindex = element1.data.findIndex((y) => y.date == subdate);
          if (subindex != -1) {
            let element2 = element1.data[subindex];
            avglist.push(element2.avgprice);
            volumelist.push(element2.volume);
          } else {
            avglist.push(0);
            volumelist.push(0);
          }
        }

        let volumeobj = {
          name: element1.name + "交易量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);//設定市場交易量長條圖資料

        let avgobj = {
          name: element1.name + "拍賣均價",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);//設定市場價格均價折線圖資料
        let volumeoption = {},
          avgoption = {};
        //設定y軸標題資料
        if (k == 0) {
          volumeoption = {
            seriesName: "交易量",
            max: maxvolume,
            min: 0,
            tickAmount:5,
            labels:{
                formatter: function(val){
                    if(window.isNaN(val)) return 0;
                    return val.toFixed(0);
                }
            },
            title: {
              text: "交易量(公斤)",
            },
          };

          avgoption = {
            seriesName: "拍賣均價",
            showAlways: false,
            opposite: true,
            max: maxprice,
            min: 0,
            tickAmount:5,
            labels:{
              formatter: function(val){
                if(window.isNaN(val)) return 0;
                return val.toFixed(0);
              }
            },
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };
        } else {
          volumeoption = {
            seriesName: "交易量",
            max: maxvolume,
            min: 0,
            show: false,
          };

          avgoption = {
            seriesName: "拍賣均價",
            show: false,
            max: maxprice,
            min: 0,
          };
        }

        this.fruit.obj.chart.options.yaxis.push(volumeoption);
        this.fruit.obj.chart.options.yaxis.push(avgoption);
      }
      //fruit.averageprice表嘉義產地均價是否被勾選
      //fruit.maintainprice表農糧署產地價格監控是否被勾選
      if (this.fruit.averageprice || this.fruit.maintainprice) {
        let averagelist2 = [],
          mantainlist2 = [];
        for (let l in datelist) {
          let averagelist3 = [],
            mantainlist3 = [],
            datelist3 = [];
          let dateelement = datelist[l];
          for (let n in this.fruit.fruitlist.items) {
            let subitem5 = this.fruit.fruitlist.items[n];
            // let subdate5 = subitem5.ANA_DATE.split("-"); //舊的，切成月份用
            // let subtime5 = subdate5[0] + "-" + subdate5[1]; //舊的，切成月份用
            if (
              datelist3.indexOf(subitem5.ANA_DATE) == -1 &&
              subitem5.ANA_DATE == dateelement &&
              subitem5.CROP_CODE == this.fruit.fruitlist.value.code
            ) {
              if (this.fruit.averageprice) {
                let avgprice =
                  (subitem5.CM_PRICE_C +
                    subitem5.CM_PRICE_M +
                    subitem5.CM_PRICE_F) /
                  3;
                averagelist3.push(avgprice);
              }

              if (this.fruit.maintainprice) {
                mantainlist3.push(subitem5.CM_PRICE_MON);
              }
              datelist3.push(subitem5.ANA_DATE);
            }
          }
          let avg2 = 0,
            volume2 = 0,
            avgcounter = 0,
            volumecounter = 0;
          console.log("averagelist3",averagelist3);
          if (this.fruit.averageprice) {
            averagelist3.forEach((y) => {
              if (y != 0) avgcounter++;
              avg2 += y;
            });
            if (avgcounter != 0) {
              let value1 = avg2 / avgcounter;
              averagelist2.push(value1.toFixed(2));//取到小數點第二位
              //averagelist2.push(Math.round(value1));//四捨五入到整數
            } else {
              averagelist2.push(0);
            }
          }
          if (this.fruit.maintainprice) {
            mantainlist3.forEach((z) => {
              if (z != 0) volumecounter++;
              volume2 += z;
            });
            if (volumecounter != 0) {
              let value2 = volume2 / volumecounter;
              mantainlist2.push(value2.toFixed(2));
            } else {
              mantainlist2.push(0);
            }
          }
        }
        
        if (averagelist2.length > 0) {
          let obj = {
            name: "嘉義縣產地均價",
            type: "line",
            data: averagelist2,
          };
          serieslist.push(obj);
          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
              max: maxprice,
              min: 0,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }

        if (mantainlist2.length > 0) {
          let obj = {
            name: "農糧署產地價格監控",
            type: "line",
            data: mantainlist2,
          };
          serieslist.push(obj);
          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
              max: maxprice,
              min: 0,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }
      }

      this.fruit.obj.chart.series = serieslist;
      let datelist2 = this.getnewdate2(datelist); //舊的，沒formatter
      this.fruit.obj.chart.options.labels = datelist2;  //舊的沒formatter
      if(this.dataLabels) this.fruit.obj.chart.options.dataLabels.enabled =true;
      else this.fruit.obj.chart.options.dataLabels.enabled =false;
      //this.fruit.obj.chart.options.labels = datelist;//舊的-搭配labels:formatter

      this.parseSpecificStingToDashed();

      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
        this.ifloading = false;
        this.$nextTick(() => {
          let markers = document.getElementsByClassName(
            "apexcharts-legend-marker"
          );
          // markers.forEach((x) => {
          //   console.log(x.nextSibling.innerText);
          // });
          for (let i = 0; i < markers.length; i++) {
            let marker = markers[i];
            if (marker.nextSibling && marker.nextSibling.innerText === "全國拍賣均價") {
              const imgURL = 'imgs/line-dash01.svg';
              const xhr = new XMLHttpRequest();
              xhr.open('GET', imgURL, true);
              xhr.responseType = 'blob';
              xhr.onload = function() {
                if (this.status === 200) {
                  const blob = this.response;
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = function() {
                    const base64data = reader.result.replace(/^data:.+;base64,/, '');
                    marker.outerHTML =
                      '<span class="apexcharts-legend-marker" rel="' +
                      i +
                      1 +
                      '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="data:image/svg+xml;base64,' + base64data + '" crossorigin="anonymous" /></span>';
                  };
                }
              };
              xhr.send();
              // marker.outerHTML =
              //   '<span class="apexcharts-legend-marker" rel="' +
              //   i +
              //   1 +
              //   '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash01.svg" crossorigin="anonymous" /></span>';
              
            } else if (marker.nextSibling && marker.nextSibling.innerText === "嘉義縣產地均價") {
              const imgURL = 'imgs/line-dash02.svg';
              const xhr = new XMLHttpRequest();
              xhr.open('GET', imgURL, true);
              xhr.responseType = 'blob';
              xhr.onload = function() {
                if (this.status === 200) {
                  const blob = this.response;
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = function() {
                    const base64data = reader.result.replace(/^data:.+;base64,/, '');
                    marker.outerHTML =
                '<span class="apexcharts-legend-marker" rel="' +
                i +
                1 +
                '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="data:image/svg+xml;base64,' + base64data + '" crossorigin="anonymous" /></span>';
                  };
                }
              };xhr.send();
              // marker.outerHTML =
              //   '<span class="apexcharts-legend-marker" rel="' +
              //   i +
              //   1 +
              //   '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash02.svg" crossorigin="anonymous" /></span>';
            }
          }
        });
      }
    },
    parseSpecificStingToDashed() {
      let num = this.fruit.obj.chart.series.length;
      this.fruit.obj.chart.options.stroke = {
        show: true,
        width: new Array(num).fill(2),
        curve: "smooth",
        dashArray: new Array(num).fill(0),
      };
      this.fruit.obj.chart.options.colors = [
        "#33a5fb",
        "#775dd0",
        "#1c22ce",
        "#ff7b3d",
        "#f9b5c0",
        "#4c1a11",
        "#6f5c5d",
        "#88715c",
        "#86a3be",
      ];

      let index1 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "全國拍賣均價"
      );
      let index2 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "嘉義縣產地均價"
      );
      let index3 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "農糧署產地價格監控"
      );

      if (index1 != -1 || index2 != -1 || index3 != -1) {
        if (index1 != -1)
          this.fruit.obj.chart.options.stroke.dashArray[index1] = 15;
        this.fruit.obj.chart.options.colors[index1] = "#19535f";
        if (index2 != -1)
          this.fruit.obj.chart.options.stroke.dashArray[index2] = 35;
        this.fruit.obj.chart.options.colors[index2] = "#feb019";
        if (index3 != -1)
          this.fruit.obj.chart.options.colors[index3] = "#ff4560";
      }
      // console.log([
      //   index1,
      //   index2,
      //   index3,
      //   this.fruit.obj.chart.options.stroke,
      //   this.fruit.obj.chart.options.colors,
      //   this.fruit.obj.chart.series,
      // ]);
    },
    getnewdate(date, index) {
      let firstdate = date.split("-");
      firstdate[0] = parseInt(firstdate[0]) + 1911;
      let subdate = new Date(firstdate.join("-"));
      if (index == 0) {
        subdate.setDate(subdate.getDate() - 1);
      } else {
        subdate.setDate(subdate.getDate() + 1);
      }
      let formatDate =
        parseInt(subdate.getFullYear()) -
        1911 +
        "-" +
        (subdate.getMonth() + 1) +
        "-" +
        subdate.getDate();
      return formatDate;
    },
    getnewdate2(date) {
      let datelist = [];
      date.forEach((x) => {
        let date = x.split('T')[0].split("-");
        date[0] = parseInt(date[0]) - 1911;
        datelist.push(date.join("/"));
      });
      return datelist;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    //圖表下載
    downloadPng(){
      let that = this
      //打开loading
      that.savePosterLoading = true
      
       //两个参数：所需要截圖的元素id，截圖后要執行的函数， canvas为截圖後返回的最后一个canvas
      var shareContent = document.getElementById('apexchartImg');

      var width = shareContent.offsetWidth;
      var height = shareContent.offsetHeight;
      var canvas = document.createElement("canvas");
      var scale = 5; //为了下载出更清晰的圖片，值越大越清晰
      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.getContext("2d").scale(scale, scale);


      var opts = {
          scale: 1,//不管上面的scale是多少倍，只能取1，否則會顯示不完全
          allowTaint:true,//允許跨域
          tainttest: true,
          useCORS: true,
          canvas: canvas,
          logging: true,
          width: width,
          height: height,
          scrollY: 0,
          scrollX: 0,
          ignoreElements: element => element.tagName === "BUTTON",     
      };


      let downloadName = 'apexchartImg'
      html2canvas(shareContent,opts).then(
        function(canvas) {
          
        //直接将canvas保存为圖片
          canvas.mozImageSmoothingEnabled = false
          canvas.webkitImageSmoothingEnabled = false
          canvas.msImageSmoothingEnabled = false
          canvas.ImafeSmoothingEnable = false
          Canvas2Image.saveAsImage(canvas, canvas.width, canvas.height,'PNG',downloadName);

          //關閉loading
          that.savePosterLoading = false
        },1000

        );
        
    },
  },
};
</script>
